import { render, staticRenderFns } from "./AggregateChart.vue?vue&type=template&id=67ddd278"
import script from "./AggregateChart.vue?vue&type=script&lang=js"
export * from "./AggregateChart.vue?vue&type=script&lang=js"
import style0 from "./AggregateChart.vue?vue&type=style&index=0&id=67ddd278&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports